import _ from 'underscore';

export default class UserDeliveryTerm {
  constructor($scope, GeoService) {
    $scope.$watch('term.country_id', function() {
      if ($scope.term.country_id) {
        GeoService.get_cities($scope.term.country_id).then(function(data) {
          $scope.term.cities = data.cities;
          if (!_.findWhere(data.cities, {id: $scope.term.city_id}))
            $scope.term.city_id = null;
        });
      }
    });
  }
}

UserDeliveryTerm.$inject = ['$scope', 'GeoService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-delivery-term.ctrl.js